import { Component, OnInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'loyaltic-header-comingsoon',
  templateUrl: './header-comingsoon.component.html',
  styleUrls: ['./header-comingsoon.component.scss']
})
export class HeaderComingsoonComponent implements OnInit {
  allowedCulturesForBranding = ['da-DK', 'nb-NO'];
  getTranslateDefaultLang: string;

  constructor(
    @Inject('ImagePath') public ImagePath,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.getTranslateDefaultLang = this.translate.defaultLang;
  }

  isAegBrandingCulture(): boolean {
    return this.allowedCulturesForBranding.includes(this.getTranslateDefaultLang);
  }
}
